import { Card, IconButton, Typography } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import { questionLabelText } from 'utils/question-label';

import { DragPreviewCardProps } from './types';

export const DragPreviewCard = ({
  title,
  width,
  subtitle,
  showHandle = false,
}: DragPreviewCardProps) => (
  <Card
    className="p-4"
    variant="outlined"
    style={{ width: width ?? undefined }}
  >
    <div className="flex min-w-0 items-center gap-3">
      {showHandle && (
        <IconButton
          size="small"
          aria-label="Drag field"
          className="cursor-grab border border-current/20"
        >
          <DragIndicatorIcon fontSize="small" />
        </IconButton>
      )}

      <div className="min-w-0">
        <Typography variant="subtitle2">{title}</Typography>
        {subtitle && (
          <Typography variant="caption" color="textSecondary">
            {questionLabelText(subtitle)}
          </Typography>
        )}
      </div>
    </div>
  </Card>
);
